import React, { useCallback } from 'react';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';

type SelectFieldProps<T extends string | number> = Omit<
    React.ComponentProps<typeof Select>,
    'value' | 'onChange'
> & {
    value: T;
    onChange: (value: T) => void;
    options: { value: T; label: string | React.ReactNode }[];
};

const SelectField = <T extends string | number>({
    value,
    onChange,
    options,
    ...props
}: SelectFieldProps<T>): React.ReactElement | null => {
    const handleOnChange = useCallback(
        (event: React.ChangeEvent<HTMLSelectElement>) => {
            onChange(event.target.value as T);
        },
        [onChange]
    );

    return (
        <Select {...props} value={value} onChange={handleOnChange}>
            {options.map((option) => (
                <MenuItem value={option.value} key={option.value}>
                    {option.label}
                </MenuItem>
            ))}
        </Select>
    );
};

export default SelectField;
